// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={62}
    height={62}
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.5276 46.5V46.2223H23.25H2.58333C1.97182 46.2223 1.38535 45.9794 0.952942 45.547C0.520536 45.1146 0.277612 44.5281 0.277612 43.9166V7.74996C0.277612 7.13844 0.520535 6.55197 0.952942 6.11957C1.38535 5.68716 1.97182 5.44424 2.58333 5.44424H59.4167C60.0282 5.44424 60.6147 5.68716 61.0471 6.11957C61.4795 6.55197 61.7224 7.13844 61.7224 7.74996V43.9166C61.7224 44.5281 61.4795 45.1146 61.0471 45.547C60.6147 45.9794 60.0282 46.2223 59.4167 46.2223H38.75H38.4724V46.5V51.6666V51.9442H38.75H42.625C42.8939 51.9442 43.1519 52.0511 43.342 52.2412C43.5322 52.4314 43.6391 52.6893 43.6391 52.9583V55.5416C43.6391 55.8106 43.5322 56.0685 43.342 56.2587C43.1519 56.4488 42.8939 56.5557 42.625 56.5557H19.375C19.1061 56.5557 18.8481 56.4488 18.658 56.2587C18.4678 56.0685 18.3609 55.8106 18.3609 55.5416V52.9583C18.3609 52.6893 18.4678 52.4314 18.658 52.2412C18.8481 52.0511 19.1061 51.9442 19.375 51.9442H23.25H23.5276V51.6666V46.5Z"
      fill="#46E8A8"
      stroke="#37363F"
      strokeWidth={0.555224}
    />
    <rect
      x={5.39785}
      y={9.41652}
      width={51.204}
      height={31.6855}
      rx={0.231343}
      fill="#C8FBE7"
      stroke="black"
      strokeWidth={0.462687}
    />
    <path
      d="M30.7867 34.5826C36.2907 34.5826 40.7525 30.1555 40.7525 24.6943C40.7525 19.2332 36.2907 14.806 30.7867 14.806C25.2827 14.806 20.8208 19.2332 20.8208 24.6943C20.8208 30.1555 25.2827 34.5826 30.7867 34.5826Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.512647}
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.2724 22.1844L29.4022 29.0011L25.3003 24.9312L26.8601 23.3591L29.4022 25.8813L34.7125 20.6123L36.2724 22.1844Z"
      fill="#46E8A8"
    />
  </svg>
);
const SvgMonitor = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgMonitor;
